<template>
  <div class="segway-btn" @click="emits('click')">
    <slot></slot>
  </div>
</template>
<script setup lang="ts">
const emits = defineEmits(['click']);
</script>
<style lang="scss" scoped>
.segway-btn {
  display: inline-block;
  padding: 12px 44px;
  border-radius: 25px 25px 25px 25px;
  font-size: 18px;
  // font-family: PingFang SC-Medium, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  background: linear-gradient(90deg, #33353d 0%, #555762 100%);
  cursor: pointer;
}
</style>
